import axios from "@/axios";
import Util from "@/util/util";
export const namespaced = true;

const defaultData = {
    orderId: 0,
    deliveryPlace: null,
    deliveryCountryId: null,
    deliveryUnit: null,
    deliveryStartDate: null,
    deliveryEndDate: null,
    deliveryTimeLegacy: null // do not make any updates this needs to be maintained
}

export const state = {
    deliveryInfo: Object.assign({}, defaultData),
    deliveryInfoErrors: [],
    status: false,
};

export const getters = {
    deliveryInfo: state => {
        return state.deliveryInfo;
    },
    deliveryInformationStatus: state => {
        return state.status
    },
    deliveryInfoErrors: state => {
        return state.deliveryInfoErrors
    }
};

export const mutations = {
    SET_DELIVERY_INFO(state, response) {
            state.deliveryInfo.deliveryStartDate = response.data.deliveryStartDate;
            state.deliveryInfo.deliveryEndDate = response.data.deliveryEndDate;
            state.deliveryInfo.deliveryPlace = response.data.deliveryPlace;
            state.deliveryInfo.deliveryUnit = response.data.deliveryUnit;
            state.deliveryInfo.deliveryCountryId = response.data.deliveryCountryId === 0 ? null : response.data.deliveryCountryId;

    },
    SET_STATUS(state, status) {
        state.status = status;
    },
    CLEAR_DATA(state) {
        state.deliveryInfo = Object.assign({}, defaultData)
    },
    SET_ERRORS(state, data) {
        state.deliveryInfoErrors = data;
    },
    CLEAR_ERRORS(state) {
        state.deliveryInfoErrors = [];
    }
};

export const actions = {
    clearData({ commit }) {
        commit('CLEAR_DATA');
    },
    async getDeliveryInformationStatus({ commit }, id) {
        if (id == 0) {
            commit("SET_STATUS", false)
        } else {
            return await axios.get('/api/deliveryinformation/status/' + id)
                .then(({ data }) => {
                    if(data && data.length === 0) {
                        commit("SET_STATUS", true);
                        commit("CLEAR_ERRORS");
                    } else {
                        commit("SET_STATUS", false);
                        commit("SET_ERRORS", data);
                    }
                })
        }
    },
    async loadDeliveryInformation({ commit }, orderId) {
        try {
            commit("SET_DELIVERY_INFO", await axios.get(`/api/deliveryinformation/${orderId}`));
        } 
        catch(error) {
            console.log("ERROR LOADING DELIVERY INFORMATION: ", error); //not handelled
        }
    },
    async saveDeliveryInfoToServer({ commit, state, dispatch }, orderId) {
        return new Promise((resolve, reject) => {
            state.deliveryInfo.orderId = orderId
            state.deliveryInfo.deliveryStartDate = Util.convertToDateOnly(state.deliveryInfo.deliveryStartDate)
            state.deliveryInfo.deliveryEndDate = Util.convertToDateOnly(state.deliveryInfo.deliveryEndDate)
            axios.post("/api/deliveryinformation", state.deliveryInfo)
                .then((response) => {
                    return resolve();
                })
                .catch(function (error) {
                    return reject("There was an error saving the Delivery Information to the server.");
                })
        });
    }
};